import React from 'react'

import CaretButton from '../caret-button/CaretButton.container'

import { StyledNode, StyledNodeContent, StyledNodeChildren } from './TreeView.styles'

/**
 * <Node />
 *
 * The tree is rendered as nested <ul> elements, each node is a <li>.
 *
 */
export default class Node extends React.Component {
  constructor(props) {
    super(props)

    this.isShown = false
    this.isOpen = false
    this.slot = -1
  }

  onClickCaret = e => {
    this.props.onClick(this.props.path)
  }

  render() {
    const {
      isShown,
      isParent,
      isOpen,
      slot,
      globalSlot,
      path,
      isOpenAnimIn,
      delay,
      width
    } = this.props

    const slotDelta = slot - this.slot

    this.isShown = isShown
    this.slot = slot
    this.isOpen = isOpen

    const caretButton = (isParent && path.length > 1) &&
      <CaretButton angle={isOpen ? 0 : -180} onClick={this.onClickCaret} tabIndex={globalSlot + 3} />

    const content = <React.Fragment>
      { this.props.content }
      { caretButton }
    </React.Fragment>

    const displayContent = isOpenAnimIn
      ? <StyledNodeContent isAnim={isOpenAnimIn} delay={delay}>{ content }</StyledNodeContent>
      : content

    return (
      <StyledNode width={width} slot={slot} slotDelta={slotDelta}>

        { this.props.children && <StyledNodeChildren>{ this.props.children }</StyledNodeChildren> }

        { displayContent }

      </StyledNode>
    )
  }
}
